import { render, staticRenderFns } from "./groupAuth.vue?vue&type=template&id=e042966e&scoped=true&"
import script from "./groupAuth.vue?vue&type=script&lang=js&"
export * from "./groupAuth.vue?vue&type=script&lang=js&"
import style0 from "./groupAuth.vue?vue&type=style&index=0&id=e042966e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e042966e",
  null
  
)

export default component.exports